export const getAuthToken = () => {
  const cookies = document.cookie.split(";");
  const tokenCookie = cookies.find((cookie) =>
    cookie.trim().startsWith("Q8TechAuth=")
  );
  return tokenCookie ? tokenCookie.split("=")[1] : null;
};

export const setAuthToken = (token) => {
  const date = new Date();
  date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
  document.cookie = `Q8TechAuth=${token}; expires=${date.toUTCString()}; path=/`;
};

export const removeAuthToken = () => {
  document.cookie =
    "Q8TechAuth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};
